import { createClient } from "@supabase/supabase-js";
import { clientEnvironment } from "../config/env";
import { initialPasswordSetupMode } from "./authCallbackIntent";

// Import/capture the callback mode before createClient initializes and clears the URL fragment.
export { initialPasswordSetupMode };

function required(value: string | undefined, name: string): string {
  if (!value) {
    throw new Error(`C15_ENV_REQUIRED:${name}`);
  }
  return value;
}

export const supabase = createClient(
  required(clientEnvironment.supabaseUrl, "VITE_SUPABASE_URL"),
  required(clientEnvironment.supabasePublishableKey, "VITE_SUPABASE_PUBLISHABLE_KEY"),
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
